// Web Crypto API AES-GCM encryption/decryption
const ENCRYPTION_IV = new Uint8Array(12); // 12 bytes IV for AES-GCM

function strToUint8Array(str: string): Uint8Array {
  return new TextEncoder().encode(str);
}

function uint8ArrayToStr(arr: Uint8Array): string {
  return new TextDecoder().decode(arr);
}

export function keyTo256Hash(key: string) {
  const encoder = new TextEncoder();
  const data = encoder.encode(key);
  return window.crypto.subtle.digest('SHA-256', data);
}

export function buf2hex(buffer: ArrayBuffer) {
  // buffer is an ArrayBuffer
  return Array.from(new Uint8Array(buffer))
    .map((x) => x.toString(16).padStart(2, '0'))
    .join('');
}

export async function encrypt(data: string, _key: string) {
  const key = await keyTo256Hash(_key);
  const keyMaterial = await window.crypto.subtle.importKey(
    'raw',
    key,
    'AES-GCM',
    false,
    ['encrypt'],
  );
  const enc = await window.crypto.subtle.encrypt(
    {
      name: 'AES-GCM',
      iv: ENCRYPTION_IV,
    },
    keyMaterial,
    strToUint8Array(data),
  );
  // Convert ArrayBuffer to base64 string
  const uint8 = new Uint8Array(enc);
  let binary = '';
  for (let i = 0; i < uint8.length; i++) {
    binary += String.fromCharCode(uint8[i]);
  }
  return {
    data: btoa(binary),
    key: buf2hex(key),
  };
}

export async function decrypt(data: string, _key: string): Promise<string> {
  const key = await keyTo256Hash(_key);
  const keyMaterial = await window.crypto.subtle.importKey(
    'raw',
    key,
    'AES-GCM',
    false,
    ['decrypt'],
  );
  const encryptedBytes = Uint8Array.from(atob(data), (c) => c.charCodeAt(0));
  const dec = await window.crypto.subtle.decrypt(
    {
      name: 'AES-GCM',
      iv: ENCRYPTION_IV,
    },
    keyMaterial,
    encryptedBytes,
  );
  return uint8ArrayToStr(new Uint8Array(dec));
}
